import React from 'react';
import { useSalesMeetingLinkQuery } from '~/libs/gql/queries/salesforce/salesMeetingLinkQuery.generated';

type UseAppointmentLinkOptions = {
  skip?: boolean;
};

export const useAppointmentLink = ({ skip = false }: UseAppointmentLinkOptions = {}) => {
  const query = useSalesMeetingLinkQuery({ skip });

  const appointmentLink = React.useMemo(
    () => query.data?.salesMeetingLink || null,
    [query.data?.salesMeetingLink],
  );

  return {
    appointmentLink,
    query,
  };
};
